module.exports = __webpack_public_path__ + "img/sad_face_monochromatic.94488577.svg";